import React, { useMemo, useState } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { getPlaceholderText } from '../../constants/placeholder';
import { Justify } from 'tea-component';
import moment from 'moment';
import './index.scss';
import SearchCommon from '@gp/components/SearchCommon';
import { toProjectDetails, findNameByTreeProjectId } from '@gp/utils/project';

export default function FilterFixedHeader(props: any) {
  const {
    change,
    filterValue,
    lang = 'en-US',
    filterFixed = false,
    fields,
    controls,
    headerTitle = '',
    headerOther = '',
    searchPlaceholder = 'Search any project in the list',
    currentPage = '',
    hasSearchBtn = true,
    showRightBtn,
    rightBtnText = 'Details',
    formatSearchResults,
    updateDeps,
    handleSearch,
    getSearchList,
    selectedValue,
    searchList,
    setSearchList,
    searchVal,
    setSearchVal,
  } = props;

  const getCommonValue = (_key: any, valueObj: any, controlsObj: any) => {
    if (Array.isArray(valueObj) && valueObj?.length > 0) {
      if (valueObj?.length === 1) {
        if (_key === 'project_id') {
          return findNameByTreeProjectId(controlsObj?.options, valueObj?.[0]);
        }
        if (Array.isArray(controlsObj?.options)) {
          const valueObjTemp =
            controlsObj?.options?.find(
              (item: any) => item.value === valueObj?.[0],
            ) || {};
          return valueObjTemp?.text || valueObjTemp?.label || valueObj?.[0];
        }
        return valueObj?.[0];
      }
      if (
        controlsObj?.options?.length === valueObj?.length ||
        controlsObj?.allValues?.length === valueObj?.length
      ) {
        return 'All';
      }
      return valueObj?.length;
    }
    if (typeof valueObj === 'string') {
      return valueObj;
    }
    return '';
  };

  const renderFixedHeaderTitle = {
    common: (_key: string, _keyValueObj: any, _fieldsObj: any) => {
      if (
        ['Current Milestone', 'Next Milestone']?.includes(_fieldsObj?.label)
      ) {
        return { title: _fieldsObj?.label };
      }
      return { title: getPlaceholderText(_key, lang) };
    },
    composedDatePicker: (_key: string, _keyValueObj: any) => {
      return { title: getPlaceholderText(_keyValueObj?.granularity, lang) };
    },
    rangePicker: (_key: string, _keyValueObj: any) => {
      return { title: getPlaceholderText(_keyValueObj?.dateType, lang) };
    },
  } as any;

  const renderFixedHeaderValue = {
    common: (_key: string, _keyValueObj: any, _controlsObj: any) => {
      return { value: getCommonValue(_key, _keyValueObj, _controlsObj) };
    },
    composedDatePicker: (_key: string, _keyValueObj: any) => {
      if (Array.isArray(_keyValueObj?.date) && _keyValueObj?.date?.length > 1) {
        let startTime = _keyValueObj?.date[0];
        let endTime = _keyValueObj?.date[1];
        switch (_keyValueObj?.granularity) {
          case 'month':
            startTime = moment(_keyValueObj?.date[0]).format('YYYY-MM');
            endTime = moment(_keyValueObj?.date[1]).format('YYYY-MM');
            break;
          case 'year':
            startTime = moment(_keyValueObj?.date[0]).format('YYYY');
            endTime = moment(_keyValueObj?.date[1]).format('YYYY');
            break;
          case 'quarter':
            startTime = `${moment(_keyValueObj?.date[0])?.format(
              'YYYY',
            )}-Q${moment(_keyValueObj?.date[0])?.quarter()}`;
            endTime = `${moment(_keyValueObj?.date[1])?.format(
              'YYYY',
            )}-Q${moment(_keyValueObj?.date[1])?.quarter()}`;
            break;
        }
        return {
          value: `${startTime}~${endTime}`,
        };
      }
      return { value: '' };
    },
    dueDate: (_key: string, _keyValueObj: any) => {
      return {
        value: `${_keyValueObj?.startDate}~${_keyValueObj?.endDate}`,
      };
    },
    rangePicker: (_key: string, _keyValueObj: any) => {
      const startTime =
        _keyValueObj?.dateType === 'month'
          ? moment(_keyValueObj?.startDate).format('YYYY-MM')
          : _keyValueObj?.startDate;
      const endTime =
        _keyValueObj?.dateType === 'month'
          ? moment(_keyValueObj?.endDate).format('YYYY-MM')
          : _keyValueObj?.endDate;
      return {
        value: `${startTime}~${endTime}`,
      };
    },
  } as any;

  const fieldsKeyList = useMemo(() => {
    return fields?.map((item: any) => item.key);
  }, [fields]);

  const filterShowElements = useMemo(() => {
    return fieldsKeyList?.map((key: string) => {
      const keyValueObj = filterValue[key] || {};
      const controlsObj = controls[key] || {};
      const fieldsObj = fields?.find((item: any) => item.key === key) || {};
      const renderTitle =
        renderFixedHeaderTitle[key] || renderFixedHeaderTitle.common;
      const { title } = renderTitle(key, keyValueObj, fieldsObj);
      const renderValue =
        renderFixedHeaderValue[key] || renderFixedHeaderValue.common;
      const { value } = renderValue(key, keyValueObj, controlsObj);

      return (
        <div className="filterbox-left-flex" key={key}>
          <span className="filterbox-left-describe">{title}</span>
          <span className="filterbox-left-text">{value}</span>
        </div>
      );
    });
  }, [filterValue, fieldsKeyList, controls]);

  const [showNull, setShowNull] = useState(false);

  function onClickChange() {
    setShowNull(true);
    change();

    setTimeout(() => {
      setShowNull(false);
    }, 300);
  }

  const handleGoToProjectDetails = (payload: any, isJump = true) => {
    const { project_id: id, name } = payload || {};
    return toProjectDetails({ id, name }, null, isJump);
  };

  return (
    <div className="dbg-filterfixed-header-wrapper">
      <div className="dbg-header-title-content">
        <div className="tea-layout__header-title">
          <Justify
            className="dbg-header-title-content-justify-container"
            left={
              <div className="dbg-header-title-content-justify-container-left">
                <h2 className="tea-h2">{headerTitle}</h2>
                {headerOther && <div className="header-des">{headerOther}</div>}
              </div>
            }
            right={
              <div className="dbg-header-title-content-justify-container-right">
                <SearchCommon
                  placeholder={searchPlaceholder}
                  currentPage={currentPage}
                  hasSearchBtn={hasSearchBtn}
                  getSearchList={getSearchList}
                  formatSearchResults={formatSearchResults}
                  onRightBtnClick={handleGoToProjectDetails}
                  showRightBtn={showRightBtn}
                  rightBtnText={rightBtnText}
                  updateDeps={updateDeps}
                  submit={handleSearch}
                  isFixedSearch={true}
                  searchList={searchList}
                  setSearchList={setSearchList}
                  searchVal={searchVal}
                  setSearchVal={setSearchVal}
                />
              </div>
            }
          />
        </div>
      </div>
      {filterFixed && (
        <div
          className="dbg-filterbox-header-flex dbg-header-filter-content"
          onClick={onClickChange}
        >
          <div className="filterbox-left">
            <div className="filterbox-left-flex">
              <SvgIcon type="funnel" className="filterbox-left-describe" />
              <span className="filterbox-left-text">
                {selectedValue?.name || 'My Filter'}
              </span>
            </div>
            {!showNull && (filterShowElements as any)}
          </div>
          <div className="filterbox-right">
            <span>{'Show'}</span>
            <SvgIcon type="point-down" className="filterbox-right-icon" />
          </div>
        </div>
      )}
    </div>
  );
}
